import { MDBIcon } from "mdb-react-ui-kit";
import { useContext, useState } from "react";
import { ResumeContext } from "../../context/resume/resume-context";
import { TranslationContext } from "../../context/translations/translations-context";
import AddDiploma from "./diplomas/AddDiploma";
import DiplomaList from "./diplomas/DiplomaList";


export default function DiplomasSection() {
    const [ isVisible, setIsVisible ] = useState( false );
    const { translations } = useContext( TranslationContext );
    const { validateForm } = useContext( ResumeContext );

    return (
        <div  className="text-white">
            <div className="subtitre-cv-container text-underline d-flex align-items-center gap-2"
                 onClick={ () => setIsVisible( !isVisible ) }
                 style={ { cursor: "pointer" } }
            >
                <h4 className="text-underline pt-1 text-white">{ translations.diplomasSection.title }</h4>
                <div className="line bg-white"></div>
                <MDBIcon
                    fas
                    icon={ "graduation-cap" }
                    style={ { color: "white" } }
                    size="lg"
                />
            </div>
            { isVisible && (
                <>
                    <DiplomaList/>
                    <AddDiploma/>
                </>
            ) }
        </div>
    );
}

